import { log, refactorReviewQuestions } from '../plugins/helpers'
import { axios } from '../plugins/axios'
import Vue from 'vue'

export default {

    namespaced: true,

    state: {
        review_questions: null
    },

    mutations: {
        SET_REVIEW_QUESTIONS(state, payload) {
            state.review_questions = refactorReviewQuestions(payload)
            log('review questions', payload)
        }, 
        UPDATE_COACHING_USED(state, question_index){
        
           Vue.set(state.review_questions[question_index], 'coaching_used', true)

        }
    },

    actions: {

        setReviewQuestions({ commit }, payload) {
            commit('SET_REVIEW_QUESTIONS', payload)
        },

        async submitCoaching({ commit, dispatch , rootState}, payload){

            let { current_question_index } = payload

            try {
            
                axios.post(rootState.api.REQUEST_COACHING, payload)        
                commit("UPDATE_COACHING_USED", current_question_index)

              } catch (error) {
                dispatch('catchAllErrors', error, { root: true })
              }
        

        }
    }

}
